export const months = {
    jan: 0,
    feb: 0,
    mar: 0,
    apr: 0,
    may: 0,
    jun: 0,
    jul: 0,
    aug: 0,
    sep: 0,
    oct: 0,
    nov: 0,
    dec: 0
  };

  export const weeks = {
    week1: 0,
    week2: 0,
    week3: 0,
    week4: 0,
    week5: 0,
    week6: 0,
    week7: 0,
    week8: 0,
    week9: 0,
    week10: 0,
    week11: 0,
    week12: 0,
    week13: 0,
    week14: 0,
    week15: 0,
    week16: 0,
    week17: 0,
    week18: 0,
    week19: 0,
    week20: 0,
    week21: 0,
    week22: 0,
    week23: 0,
    week24: 0,
    week25: 0,
    week26: 0,
    week27: 0,
    week28: 0,
    week29: 0,
    week30: 0,
    week31: 0,
    week32: 0,
    week33: 0,
    week34: 0,
    week35: 0,
    week36: 0,
    week37: 0,
    week38: 0,
    week39: 0,
    week40: 0,
    week41: 0,
    week42: 0,
    week43: 0,
    week44: 0,
    week45: 0,
    week46: 0,
    week47: 0,
    week48: 0,
    week49: 0,
    week50: 0,
    week51: 0,
    week52: 0
  };

  